import React, { useEffect } from 'react';
import { Tray } from '../../../components/elements';
import { isSurveyTemplateUnitData } from '../../../components/Surveys/isSurveyTemplateUnitData';
import { ISurveyTemplateElementData } from '../../../components/Surveys/ISurveyTemplateElementData';
import { ISurveyTemplateElementGroupData } from '../../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../../components/Surveys/ISurveyTemplateUnitData';
import { loadStreets } from './searchStreet';
import { SurveyEditAoInspectieOverspanningenUnit } from './SurveyEditAoInspectieOverspanningenUnit';

export function SurveyEditAoInspectieOverspanningenDecomposition(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateElementData
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    useEffect(() => {
        void loadStreets();
    }, []);

    if (isSurveyTemplateUnitData(props)) {
        return <SurveyEditAoInspectieOverspanningenUnit {...props} />;
    }
    return <Tray>&nbsp;</Tray>;
}
